import { render, staticRenderFns } from "./AppFormatNumber.vue?vue&type=template&id=b3db87be&scoped=true&"
import script from "./AppFormatNumber.vue?vue&type=script&lang=js&"
export * from "./AppFormatNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3db87be",
  null
  
)

export default component.exports